export const defaultFileInformation = {
    size: 0,
    unit: "KB",
    name: 'home:file_name'
};

export const getTypeFile = (types = "png,jpeg") => {
    const defaultTypeFile = {
        png: "image/x-png,image/png",
        jpeg: "image/jpeg",
        jpg: "image/jpg",
        xslx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    }

    const arrayTypes = types.split(",");
    return arrayTypes.map(type => defaultTypeFile[type.toLowerCase()]).join(",");
}